import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from 'environments/environment';
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';

if (environment.production) {
  enableProdMode()
}

bootstrapApplication(
  AppComponent,
  {
    ...appConfig,
    providers: [provideZoneChangeDetection(), ...appConfig.providers]
  }
).catch(
  (err) => console.error(err)
)
